import {
  useSalesServiceSalesOrdersApproveCreate,
  useSalesServiceSalesOrdersCheckoutCreate
} from '@insurance/api/queries'
import { InvoiceDetail } from '@insurance/api/requests'
import { usePermissionRestriction } from '@shared/hooks'
import { AppPermissions } from '@shared/types'
import { showApiErrors } from '@shared/utils'
import { FormInstance } from 'antd'

type Options = {
  formInstance?: FormInstance
  onSuccess?: (data: InvoiceDetail) => void
}

export const useModifyPayment = ({ formInstance, onSuccess }: Options) => {
  const { hasPermission } = usePermissionRestriction()

  const handleFinishError = (error: unknown) => {
    showApiErrors(error, formInstance)
  }

  const { mutateAsync: checkout, isPending: isCheckoutPending } =
    useSalesServiceSalesOrdersCheckoutCreate({
      onError: handleFinishError,
      onSuccess
    })

  const { mutateAsync: approve, isPending: isApprovePending } =
    useSalesServiceSalesOrdersApproveCreate({
      onError: handleFinishError
    })

  const onFinishPay = async (
    orderId: number,
    onSuccess?: Options['onSuccess']
  ) => {
    const orderData = formInstance?.getFieldsValue(true)

    const orderApprove = await approve({ id: orderId, requestBody: {} })
    const invoice = await checkout({
      id: orderApprove.id!,
      requestBody: { credit: orderData?.credit || undefined }
    })

    onSuccess?.(invoice)
  }

  return {
    payPermission: hasPermission([AppPermissions.APPROVE_ORDER]),
    isPaymentLoading: isApprovePending || isCheckoutPending,
    onFinishPay
  }
}
